import { Link } from 'react-router-dom';

import { cn } from 'helpers/classnames';
import TrackingProgress from 'components/account/TrackingProgress';
import OrderStatus from 'components/account/OrderStatus';

import { hasShipmentBeenDelivered, hasShipmentBeenShipped } from '/helpers/MyAccountUtils';

import useMartyContext from 'hooks/useMartyContext';
import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';
import { FEATURE_KRATOS_SHIPPING_TRACKING_ENABLED } from 'constants/features';
import { toKratosUrl } from 'helpers/kratosUrlHelper';

import css from 'styles/components/account/shippingStatus.scss';

const shipmentMessageFallBack = 'Track this shipment';
export const ShippingStatus = ({
  orderId,
  shipmentId,
  status,
  onShipmentClick = f => f,
  currentShipmentNumber,
  totalShipments,
  shipmentMessage,
  trackingAvailable,
  setToolTipVisibilityforMobile,
  hideTrackingProgress = false,
  className,
  planName
}) => {
  const { isEnrolled: isKratosShippingTrackingEnabled } = useIsEnrolledInVariant(FEATURE_KRATOS_SHIPPING_TRACKING_ENABLED);
  const { testId } = useMartyContext();

  const baseUrl = `/shipments/${orderId}/${shipmentId}`;
  const shipmentTrackingUrl = isKratosShippingTrackingEnabled ? toKratosUrl(baseUrl) : baseUrl;

  if (!status) {
    return null;
  }

  const isShipped = hasShipmentBeenShipped(status);
  const isDelivered = hasShipmentBeenDelivered(status);
  const displayTrackingProgress = !hideTrackingProgress && (isShipped || isDelivered);

  return (
    <div className={cn(css.shippingStatusContainer, className)} data-test-id={testId('shippingStatus')}>
      <OrderStatus setToolTipVisibilityforMobile={setToolTipVisibilityforMobile} status={status} planName={planName} />
      {currentShipmentNumber > 0 && totalShipments > 0 && (
        <p className={cn(css.shipmentNumber, 'zappos:body-m')}>{`Shipment ${currentShipmentNumber} of ${totalShipments}`}</p>
      )}
      {trackingAvailable
        ? orderId &&
          shipmentId && (
            <Link onClick={onShipmentClick} className={cn(css.shipmentMessage, 'zappos:body-m-medium')} to={shipmentTrackingUrl}>
              {shipmentMessage || shipmentMessageFallBack}
            </Link>
          )
        : !!shipmentMessage && <p className={cn(css.shipmentMessage, 'zappos:body-m')}>{shipmentMessage}</p>}
      {displayTrackingProgress && (
        <div className={css.trackingProgressContainer}>
          <TrackingProgress isShipped={isShipped} isDelivered={isDelivered} />
        </div>
      )}
    </div>
  );
};

export default ShippingStatus;
